import { useCallback, useEffect, useRef, useState } from "react";
import { legacyCasesService } from "../services/legacyCases.service";

export function useLegacyReportBlob(contentUrl: string) {
  const [url, setUrl] = useState<string>();
  const [failed, setFailed] = useState(false);
  const currentUrl = useRef<string>();
  const active = useRef(false);
  const requestId = useRef(0);
  const load = useCallback(async () => {
    requestId.current += 1;
    const id = requestId.current;
    setFailed(false);
    try {
      const blob = await legacyCasesService.document(contentUrl);
      if (!active.current || id !== requestId.current) return;
      if (currentUrl.current) URL.revokeObjectURL(currentUrl.current);
      currentUrl.current = URL.createObjectURL(blob);
      setUrl(currentUrl.current);
    } catch {
      if (active.current && id === requestId.current) setFailed(true);
    }
  }, [contentUrl]);
  useEffect(() => {
    active.current = true;
    void load();
    return () => {
      active.current = false;
      requestId.current += 1;
      if (currentUrl.current) URL.revokeObjectURL(currentUrl.current);
    };
  }, [load]);
  return { url, failed, load };
}
